import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getFetchError, getIsFetching, getPpsiById } from '../selectors';
import { fetchGlobalPpsi } from '../actions';

const useGlobalPpsi = (id, { forceFetch = false }) => {
  const dispatch = useDispatch();

  const [isMounted, setIsMounted] = useState(false);
  const ppsi = useSelector(getPpsiById(id));
  const isFetchingPpsi = useSelector(getIsFetching);
  const fetchError = useSelector(getFetchError);
  const isFetching = !setIsMounted ? true : isFetchingPpsi;
  const isFetched = !!ppsi;

  useEffect(() => {
    if (isMounted) {
      return;
    }
    if (!isFetched || forceFetch) {
      dispatch(fetchGlobalPpsi(id));
    }
    setIsMounted(true);
  }, [id, dispatch, forceFetch, isFetched, isMounted]);

  return [isFetching ? null : ppsi, isFetching, fetchError];
};

export default useGlobalPpsi;
